var map = {
	"./azulproject.jpg": 60,
	"./bvslogo.png": 116,
	"./clockplusproject.jpg": 61,
	"./dehlilogo.png": 117,
	"./humanoidproject.jpg": 62,
	"./leadersit.png": 118,
	"./mypic.jpg": 56,
	"./nab.png": 119,
	"./newsplusproject.jpg": 63,
	"./originpulsesproject.jpg": 64,
	"./pokendexproject.jpg": 65,
	"./pulseproject.jpg": 66,
	"./rmit.png": 120,
	"./shipnow.png": 121,
	"./upwork.png": 122,
	"./voidalsproject.jpg": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;